import React from 'react'
import {
  BlockList,
  generateBackgroundStyles,
  generateColorThemeClasses,
  generateForegroundStyles,
  generatePaddingClasses,
  SectionSettingsProps,
  generateTopRadiusClasses,
  generateColumnClasses,
} from '.'

export const SectionThreeColumnBlock = (props: SectionSettingsProps) => {
  const { areas } = props

  const leftArea = areas?.find(area => area.name === 'Left')
  const middleArea = areas?.find(area => area.name === 'Middle')
  const rightArea = areas?.find(area => area.name === 'Right')

  const backgroundStyles = generateBackgroundStyles(props)
  const colorThemeClasses = generateColorThemeClasses(props)
  const paddingClasses = generatePaddingClasses(props)
  const foregroundStyles = generateForegroundStyles(props)
  const colClass = generateColumnClasses({ ...props, sectionType: 'triple' })
  const topRadiusClasses = generateTopRadiusClasses(props)

  return (
    <div
      style={{ ...backgroundStyles, ...foregroundStyles }}
      className={`${colorThemeClasses} ${paddingClasses} ${topRadiusClasses}`}
      data-block-section>
      <div className="container">
        <div className="row">
          {leftArea && (
            <div className={`col-12 ${colClass.firstCol}`}>
              <BlockList blocks={leftArea.blocks} availableColumns={4} />
            </div>
          )}
          {middleArea && (
            <div className={`col-12 ${colClass.secondCol}`}>
              <BlockList blocks={middleArea.blocks} availableColumns={4} />
            </div>
          )}
          {rightArea && (
            <div className={`col-12 ${colClass.thirdCol}`}>
              <BlockList blocks={rightArea.blocks} availableColumns={4} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
